export type MermaidOverlayAnchor = {
  height: number;
  left: number;
  top: number;
  width: number;
};

export type MermaidOverlayViewport = {
  height: number;
  width: number;
};

export type MermaidOverlayPlacement = 'above' | 'below';

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), Math.max(min, max));
}

export function clampMermaidOverlayPosition(
  anchor: MermaidOverlayAnchor,
  overlay: { height: number; width: number },
  viewport: MermaidOverlayViewport,
  placement: MermaidOverlayPlacement,
  margin = 8,
  gap = 6
) {
  const preferredTop =
    placement === 'above'
      ? anchor.top - overlay.height - gap
      : anchor.top + anchor.height + gap;
  const alternateTop =
    placement === 'above'
      ? anchor.top + anchor.height + gap
      : anchor.top - overlay.height - gap;

  const preferredFits =
    preferredTop >= margin &&
    preferredTop + overlay.height <= viewport.height - margin;
  const rawTop = preferredFits ? preferredTop : alternateTop;

  return {
    left: clamp(anchor.left, margin, viewport.width - overlay.width - margin),
    top: clamp(rawTop, margin, viewport.height - overlay.height - margin),
  };
}
